import { render, staticRenderFns } from "./Goods.vue?vue&type=template&id=b5598e18&scoped=true&"
import script from "./Goods.vue?vue&type=script&lang=js&"
export * from "./Goods.vue?vue&type=script&lang=js&"
import style0 from "./Goods.vue?vue&type=style&index=0&id=b5598e18&scoped=scoped&lang=css&"
import style1 from "./Goods.vue?vue&type=style&index=1&id=b5598e18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5598e18",
  null
  
)

export default component.exports